import { gql } from "@apollo/client";

import { AssessmentSuggestionCitationFragment } from "./get-assessment-suggested-answers-query";

export default gql`
  ${AssessmentSuggestionCitationFragment}
  query getAssessmentAnswerSuggestedAnswers($assessmentAnswerId: Int!) {
    assessmentAnswer(answerId: $assessmentAnswerId) {
      id
      question {
        id
        title
      }
      ... on TextAssessmentAnswerNode {
        inferredSources {
          edges {
            node {
              ...AssessmentSuggestionCitation
            }
          }
        }
      }
    }
  }
`;
